// Definição para o modal de busca de Regras de Acesso
// Utilizada no cadastro de Regras de Acesso para seleção da Regra Pai (hierarquia)

export const criarConfigBuscaRegraAcesso = () => ({
  label: 'Regra Pai (Grupo)',
  placeholder: 'Chave ou Descrição...',
  titulo: 'Selecionar Regra de Acesso',
  endpointApi: 'RegrasAcesso',
  idField: 'idRegraAcesso',
  displayField: 'chave',
  descField: 'descricao',

  camposFiltro: [
    { label: 'Módulo', model: 'modulo', tipo: 'text' },
    { label: 'Título (Menu)', model: 'titulo', tipo: 'text' }
  ],

  colunasGrid: [
    { header: 'ID', dataField: 'idRegraAcesso', width: '8%' },
    { header: 'Módulo', dataField: 'modulo', width: '31%' },
    { header: 'Descrição', dataField: 'descricao', width: '30%' },
    { header: 'Título (Menu)', dataField: 'titulo', width: '31%' }

  ],

  filtrosFixos: {
    pageSize: 100
  }
})
